var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useContext } from "react";
import { GroupsMode } from "../../../Register";
import { Button, Form, Icon } from "@brushfire/ui";
import { useSelector, useDispatch } from "react-redux";
import FormikContextListener from "../../../../../Helpers/FormikContextListener";
import { setFormIsSubmitting } from "../../../../../../store/AppState/actions";
import Constants from "../../../../../../data/constants";
import WidgetFieldset from "../../../../../Helpers/WidgetFieldset";
import { AppFormContext } from "../../../../../../App";
import useWidgetHistory from "../../../../../../hooks/useWidgetHistory";
import { removeLocal, LOCAL_STORAGE_KEYS } from "../../../../../../data/localStorageHelpers";
var useTypedSelector = useSelector;
var GroupButtons = function (_a) {
    var eventData = _a.eventData, path = _a.path, groupsMode = _a.groupsMode, setGroupsMode = _a.setGroupsMode;
    var formIsSubmitting = useTypedSelector(function (store) { return store.app; }).formIsSubmitting;
    var formikContext = useContext(AppFormContext).formikContext;
    var dispatch = useDispatch();
    var history = useWidgetHistory();
    var onSubmit = function (values, formikHelpers) {
        dispatch(setFormIsSubmitting(true));
        if (eventData) {
            if (values.mode === GroupsMode.hide) {
                removeLocal("".concat(LOCAL_STORAGE_KEYS.GROUP_ID, "-").concat(eventData === null || eventData === void 0 ? void 0 : eventData.eventNumber));
                dispatch(setFormIsSubmitting(false));
                formikHelpers.setSubmitting(false);
                setGroupsMode(values.mode);
            }
            else if (values.mode === GroupsMode.createGroup) {
                dispatch(setFormIsSubmitting(false));
                formikHelpers.setSubmitting(false);
                setGroupsMode(GroupsMode.createGroup);
            }
            else if (values.mode === GroupsMode.joinGroup) {
                dispatch(setFormIsSubmitting(false));
                formikHelpers.setSubmitting(false);
                setGroupsMode(GroupsMode.joinGroup);
            }
        }
    };
    useEffect(function () {
        if (formIsSubmitting) {
            dispatch(setFormIsSubmitting(false));
            formikContext === null || formikContext === void 0 ? void 0 : formikContext.setSubmitting(false);
        }
    }, [groupsMode]);
    var disableCartButton = !((formikContext === null || formikContext === void 0 ? void 0 : formikContext.values.mode) === GroupsMode.hide ||
        (formikContext === null || formikContext === void 0 ? void 0 : formikContext.values.mode) === GroupsMode.createGroup ||
        (formikContext === null || formikContext === void 0 ? void 0 : formikContext.values.mode) === GroupsMode.joinGroup);
    return (_jsx(_Fragment, { children: _jsx(Form, __assign({ initialValues: { mode: GroupsMode.hide }, onSubmit: onSubmit, useUnsavedPrompt: false, formikBagProps: { disableCartButton: disableCartButton } }, { children: function (_a) {
                var formikContext = _a.formikContext;
                return (_jsxs(_Fragment, { children: [_jsx(FormikContextListener, { currentPath: path, path: [
                                Constants.Routes.tickets,
                                Constants.Routes.register,
                                Constants.Routes.autoreg,
                                Constants.Routes.calendar,
                                Constants.Routes.section,
                            ], formikContext: formikContext, active: groupsMode === GroupsMode.buttons }), (eventData === null || eventData === void 0 ? void 0 : eventData.groupCentricText) && (_jsx("div", { className: "wysiwyg-text m-bottom", dangerouslySetInnerHTML: { __html: eventData === null || eventData === void 0 ? void 0 : eventData.groupCentricText } })), _jsx(WidgetFieldset, { children: _jsxs("div", __assign({ className: "btn-collection two" }, { children: [_jsxs(Button, __assign({ id: "justRegister", purpose: "info", classes: "square-choice btn-block no-border".concat(formikContext.values.mode === GroupsMode.hide ? " active" : ""), onClick: function (evt) {
                                            evt.preventDefault();
                                            evt.stopPropagation();
                                            formikContext.setFieldValue("mode", GroupsMode.hide);
                                        } }, { children: [_jsx(Icon, { icon: "calendar-check", type: "duotone" }), _jsxs("h3", { children: [(eventData === null || eventData === void 0 ? void 0 : eventData.verbiage) === "Tickets" ? "Get tickets" : "Register", " as an individual"] }), _jsx("h6", { children: "Continue without creating or joining a group" })] })), ((eventData === null || eventData === void 0 ? void 0 : eventData.isGroupCentric) || (eventData === null || eventData === void 0 ? void 0 : eventData.hasGroupTypes)) && (_jsxs(Button, __assign({ id: "createNew", purpose: "info", classes: "square-choice btn-block no-border".concat(formikContext.values.mode === GroupsMode.createGroup ? " active" : ""), onClick: function (evt) {
                                            evt.preventDefault();
                                            evt.stopPropagation();
                                            formikContext.setFieldValue("mode", GroupsMode.createGroup);
                                        } }, { children: [_jsx(Icon, { icon: "user-friends", type: "duotone" }), _jsxs("h3", { children: [(eventData === null || eventData === void 0 ? void 0 : eventData.verbiage) === "Tickets" ? "Get tickets" : "Register", " as a group"] }), _jsxs("h6", { children: ["Create or join a group to", " ", (eventData === null || eventData === void 0 ? void 0 : eventData.verbiage) === "Tickets" ? "get tickets" : "register"] })] })))] })) })] }));
            } })) }));
};
export default GroupButtons;
